import React, { useState } from 'react'
import { Box } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'
import ProfileHeader from '../../../../components/ProfileHeader'
import { Form, Formik } from 'formik'
import OutlinedTextField from '../../../../components/formFields/OutlinedTextField'
import { useEffect } from 'react'
import ticketInitialValues from './ticketInitialValues'
import ticketValidationSchema from './ticketValidationSchema'
import ItemsApi from '../../../../api/ItemsApi'
import { getTicket } from '../../../../api/TicketsApi'
import CircularProgress from '@mui/material/CircularProgress'
import Backdrop from '@mui/material/Backdrop'
import { useToastContext } from '../../../../context/ToastContext'
import { ToastType } from '../../../../components/toast/ToastType'
import { useParams } from 'react-router-dom'
import BottomNav from '../../../../components/BottomNav'
import {
  REMARKS_DOMAIN,
  REMARKS_KM,
  ROLE_BASE,
  ROLE_FLOTA,
  TK_STATUS_AUTHORIZED,
  TK_STATUS_REJECTED,
} from '../../../../utils/generalConstants'
import { HOST } from '../../../../api/config/Constants'
import Stack from '@mui/material/Stack'
import { getClassStatus } from '../../../../utils/generalUtils'
import { getSessionStorage } from '../../../../utils/StorageUtil'
import { USER_SO_KEY } from '../../../../utils/accountUtils'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Fab from '@mui/material/Fab'
import CancelIcon from '@mui/icons-material/Cancel'
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined'
import TaskAltIcon from '@mui/icons-material/TaskAltOutlined'
import Divider from '@mui/material/Divider'
import Dialog from '@mui/material/Dialog'
const TicketFormThumbnail = (props: {
  files: string[]
  placeholder?: string
}) => {
  return (
    <Box className="ticket-form-file-thumbnails">
      {props.files.map((file: string, index: number) => (
        <Box className="ticket-form-file-thumbnail" key={index}>
          <img
            alt="adjunto"
            src={`${HOST}/${file}`}
            className="ticket-form-thumbnail-img"
          />
        </Box>
      ))}
    </Box>
  )
}

type Props = {
  companyName: string
  ticketId: string
  plateNumber: string
  handleSubmit: any
  handleGoBack: any
  handleReject: any
}

export default (props: Props) => {
  const [, , showToast] = useToastContext()
  const [domainAttach, setDomainAttach] = useState<string[] | null>(null)
  const { t } = useTranslation()
  const [kmAttach, setKmAttach] = useState<string[] | null>(null)
  const [attached, setAttached] = useState<string[]>([])
  const [showBackdrop, setShowBackDrop] = useState(false)
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [seeAuthorize, setSeeAuthorize] = useState(false)
  const [seeReject, setSeeReject] = useState(false)
  const [modalReject, setModalReject] = useState(false)
  const [data, setData] = useState({
    company: '',
    userID: '',
    mileage: '',
    title: '',
    description: '',
    date: '',
    status: '',
    remarksClient: '',
    remarksInternal: '',
    idTicket: '',
  })
  const user = getSessionStorage(USER_SO_KEY)
  useEffect(() => {
    if (!document.body.classList.contains('grey-background')) {
      document.body.classList.add('grey-background')
    }

    setLoading(true)
    if (id) {
      ItemsApi.getItemByTicketId(id).then((response) => {
        let attKm: string[] = []
        let attDomain: string[] = []
        let attAll: string[] = []
        response.data.forEach((element: any) => {
          if (element.remarks === REMARKS_KM) {
            attKm.push(element?.mediaURL)
          } else if (element.remarks === REMARKS_DOMAIN) {
            attDomain.push(element?.mediaURL)
          } else {
            attAll.push(element?.mediaURL)
          }
        })
        setKmAttach(attKm)
        setDomainAttach(attDomain)
        setAttached(attAll)
      })
      getTicket(id)
        .then((response) => {
          setData({
            company: response.data.company.name,
            userID: response.data.userID,
            mileage: response.data.mileage,
            title: response.data.title,
            description: response.data.description,
            date: response.data.date,
            status: response.data.status,
            remarksClient: response.data.remarksClient,
            remarksInternal: response.data.remarksInternal,
            idTicket: response.data.idTicket,
          })

          setLoading(false)
        })
        .catch(() => {
          console.log('Error')
        })
    }
  }, [])
  const rightButton = (
    <Button
      startIcon={<ThumbUpAltOutlinedIcon />}
      type="submit"
      className="main-btn"
      color="primary"
      variant="contained"
      sx={{ ml: 3 }}
      onClick={handleAuthorize}
    >
      Autorizar
    </Button>
  )

  const rightButtonReject = (values: any) => {
    return (
      <Button
        startIcon={<CancelIcon />}
        className="main-btn"
        color="error"
        variant="contained"
        onClick={() => handleReject(values)}
      >
        Rechazar
      </Button>
    )
  }

  function handleReject(values: any) {
    console.log(values)
    if (values?.remarksClient?.length > 1) {
      setModalReject(true)
      setData(values)
    } else {
      showToast(
        ToastType.Error,
        'Error',
        'El campo Motivo del Rechazo es Obligatorio'
      )
    }
  }

  function handleAuthorize() {
    setSeeAuthorize(true)
  }
  function closeModal() {
    setModalReject(false)
  }

  function handleSubmitForm(values: any, id: string) {
    if (values?.remarksClient?.length > 1) {
      props.handleSubmit(values, id)
    } else {
      showToast(
        ToastType.Error,
        'Error',
        'El campo Observaciones al Cliente es Obligatorio'
      )
    }
  }

  return (
    <Box>
      <ProfileHeader />
      <Box className="create-maintenance-title">
        <Trans i18nKey={`screens.createMaintenance.titleAuthorize`} />
        <Stack
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          spacing={2}
        >
          <Box flexGrow="1" textAlign="left" pl={3}>
            <span className={`status-box ${getClassStatus(data?.status)}`}>
              {'Nro Tickets ' + data?.idTicket + ' - ' + data?.status}
            </span>
          </Box>
          <Box flexGrow="1" textAlign="right" pr={3}>
            <span className="header3">{data?.date}</span>
          </Box>
        </Stack>
      </Box>

      {data?.title && (
        <Formik
          initialValues={ticketInitialValues(data)}
          onSubmit={(values) => handleSubmitForm(values, id)}
          validationSchema={ticketValidationSchema}
          isInitialValid={false}
        >
          {({ isSubmitting, isValid, values }) => (
            <Form id="authorize-maintenance">
              <Box className="create-maintenance-card">
                <Box className="create-maintenance-card-title">
                  {props.plateNumber}
                </Box>
                <OutlinedTextField
                  label={`screens.createMaintenance.company`}
                  name="company"
                  autoComplete="company"
                  fullWidth={true}
                  i18n
                  requiredField
                  disabled={true}
                />
                <OutlinedTextField
                  label={`screens.createMaintenance.userID`}
                  name="userID"
                  autoComplete="userID"
                  fullWidth={true}
                  i18n
                  disabled={true}
                />
                <OutlinedTextField
                  label={`screens.createMaintenance.km`}
                  name="mileage"
                  autoComplete="mileage"
                  fullWidth={true}
                  i18n
                  disabled={true}
                />
                <Box className="ticket-form-file-thumbnails">
                  {kmAttach && (
                    <TicketFormThumbnail
                      files={kmAttach}
                      placeholder={`screens.createMaintenance.km`}
                    />
                  )}
                  {domainAttach && (
                    <TicketFormThumbnail
                      files={domainAttach}
                      placeholder={`screens.createMaintenance.domain`}
                    />
                  )}
                </Box>
                <OutlinedTextField
                  label={`screens.createMaintenance.titleField`}
                  name="title"
                  autoComplete="title"
                  fullWidth={true}
                  i18n
                  disabled={true}
                />
                <OutlinedTextField
                  label={`screens.createMaintenance.descriptionField`}
                  name="description"
                  autoComplete="description"
                  rows={5}
                  fullWidth={true}
                  i18n
                  // requiredField
                  disabled={true}
                />
                {!!attached.length && <TicketFormThumbnail files={attached} />}
              </Box>

              {data.status === 'RECHAZADA' && (
                <Box className="create-maintenance-card" mt={2}>
                  <OutlinedTextField
                    label="Motivo del Rechazo"
                    name="remarksClient"
                    autoComplete="remarksClient"
                    value={data?.remarksClient}
                    rows={5}
                    fullWidth={true}
                    disabled={true}
                  />
                </Box>
              )}

              {data.status === 'AUTORIZADA' && (
                <Box className="create-maintenance-card" mt={2}>
                  <OutlinedTextField
                    label="Observaciones al Cliente"
                    name="remarksClient"
                    autoComplete="remarksClient"
                    value={data?.remarksClient}
                    rows={5}
                    fullWidth={true}
                    disabled={true}
                  />
                </Box>
              )}

              {user && user.role !== ROLE_FLOTA && (
                <Box className="create-maintenance-card" mt={2}>
                  <OutlinedTextField
                    label="Cod ERP"
                    name="remarksInternal"
                    autoComplete="remarksInternal"
                    value={data?.remarksInternal}
                    rows={5}
                    disabled={true}
                  />
                </Box>
              )}

              <BottomNav
                hasBack="true"
                rightButton={
                  seeAuthorize
                    ? rightButton
                    : seeReject && rightButtonReject(values)
                }
              />
            </Form>
          )}
        </Formik>
      )}

      <Backdrop sx={{ color: '#fff' }} open={showBackdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  )
}
